import { render, staticRenderFns } from "./BaselTestBlock.vue?vue&type=template&id=5ff32292&scoped=true"
import script from "./BaselTestBlock.vue?vue&type=script&lang=js"
export * from "./BaselTestBlock.vue?vue&type=script&lang=js"
import style0 from "./BaselTestBlock.vue?vue&type=style&index=0&id=5ff32292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff32292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VLazy,VSpacer})
